import styles from './chart-widget.module.scss';
import StackedBarChart from './stacked-bar-chart/StackedBarChart';
import LineChart from './line-chart/LineChart';
import clsx from 'clsx';
import { GaugeChart } from './gauge-chart/GaugeChart';
import {
  InvestmentBreakdownDataPoint,
  LineChartConfig
} from 'modules/dashboard/types/widgets/widget.interfaces';
import { InvestmentBreakdownWidget } from 'modules/dashboard/components/molecules/widgets/content/investment-breakdown/InvestmentBreakdownWidget';

export enum ChartType {
  stackedBar = 'bar',
  doughnut = 'doughnut',
  gauge = 'gauge',
  line = 'line'
}

export interface ChartProps {
  chartType: ChartType;
  data: InvestmentBreakdownDataPoint[] | number[][];
  labels?: string[];
  lineChartConfig?: LineChartConfig;
}

const ChartWidget = (chartProps: ChartProps) => {
  const chart = (type: ChartType) => {
    switch (type) {
      case ChartType.stackedBar:
        return <StackedBarChart {...chartProps} />;
      case ChartType.doughnut:
        return <InvestmentBreakdownWidget />;
      case ChartType.gauge:
        return <GaugeChart {...chartProps} />;
      case ChartType.line:
        return <LineChart {...chartProps} />;
      default:
        return <p>Invalid Chart</p>;
    }
  };

  return (
    <div className={clsx(styles.chartWidget)} style={{ height: '100%', overflow: 'hidden' }}>
      {chart(chartProps.chartType)}
    </div>
  );
};

export default ChartWidget;
